/**
 * Function that create a store by collection a list of signals
 * @param signals List of signals
 * @returns
 */
var createStore = function (signals) {
    return {
        getSignals: function () { return signals; },
    };
};
export default createStore;
